import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/index.css";
import ArgonDashboard from "./argon-dashboard";

import "core-js/stable";
import "regenerator-runtime/runtime";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
const diy = JSON.parse(localStorage.getItem('TENANT_DIY'))
const favicon = diy?diy.favicon:(process.env.VUE_APP_FAVICON || "/favicon.ico"); // 环境变量或默认路径

let link = document.querySelector("link[rel~='icon']");
if (!link) {
  link = document.createElement("link");
  link.rel = "icon";
  document.head.appendChild(link);
}

link.href = favicon;

// 国际化
import i18n from "@/language";

const appInstance = createApp(App);

// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  appInstance.component(key, component);
}

appInstance.use(i18n);
appInstance.use(ElementPlus);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
